import { Plugin } from '../plugin';

export class InteractLoader extends Plugin {
}
